import { render, staticRenderFns } from "./ThreadStandardItem.vue?vue&type=template&id=15044883&scoped=true&"
import script from "./ThreadStandardItem.vue?vue&type=script&lang=ts&"
export * from "./ThreadStandardItem.vue?vue&type=script&lang=ts&"
import style0 from "./ThreadStandardItem.vue?vue&type=style&index=0&id=15044883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15044883",
  null
  
)

export default component.exports